import React, {
  Component,
  Children
} from "react";
import PropTypes from "prop-types";

import { Breakpoints } from "src/library/utils/theme";

import { Bounds } from "./Bounds";

const defaultBreakpoints = {
  sm: [ 0, 500 ],
  md: [ 501, 768 ],
  lg: [ 769, 1100 ]
};

export interface HedronProviderProps {
  breakpoints?: Breakpoints;
  padding?: string;
  children?: React.ReactNode | undefined;
}

export default class Provider extends Component<HedronProviderProps> {
  context!: {breakpoints: Breakpoints, padding?: string;};
  static contextTypes = {
    breakpoints: PropTypes.object,
    padding: PropTypes.string,
    debug: PropTypes.bool
  };

  static childContextTypes = {
    breakpoints: PropTypes.object,
    padding: PropTypes.string,
    debug: PropTypes.bool
  };

  getChildContext() {
    const {
      breakpoints: propsBreakpoints = {},
      padding: propsPadding
    } = this.props;

    const {
      breakpoints: contextBreakpoints = {},
      padding: contextPadding
    } = this.context;

    return {
      breakpoints: {
        ...defaultBreakpoints,
        ...contextBreakpoints,
        ...propsBreakpoints
      },
      padding: propsPadding || contextPadding || "5px"
    };
  }

  render() {
    return Children.only(this.props.children);
  }
}

export const withBreakpoints: <T extends React.ComponentType>(Wrapped: T) => T = WrappedComponent =>
  // eslint-disable-next-line react/no-multi-comp
  // @ts-ignore
  class extends Component {
    context!: {breakpoints: Breakpoints, padding?: string; debug: boolean;};
    // eslint-disable-line  react/prefer-stateless-function
    static contextTypes = {
      breakpoints: PropTypes.object,
      padding: PropTypes.string,
      debug: PropTypes.bool
    };

    // inherit displayName from source component
    static displayName = WrappedComponent.displayName || WrappedComponent.name;

    // inherit propTypes from source component
    static propTypes = WrappedComponent.propTypes;

    // inherit defaultProps from source component
    static defaultProps = WrappedComponent.defaultProps;

    render() {
      const {
        breakpoints, debug, padding
      } = this.context;

      const props = {
        breakpoints,
        debug
      };

      // Hacky method of ignoring some components when applying padding
      if (
        // @ts-ignore
        WrappedComponent.render ?
        // TODO: fix
        // @ts-ignore
          ![ Bounds.render.prototype ].includes(
            // @ts-ignore
            WrappedComponent.render.prototype
          ) :
          // @ts-ignore
          ![ Bounds.prototype ].includes(WrappedComponent.prototype)
      ) {
        // TODO: fix
        // @ts-ignore
        props.padding = padding;
      }

      return (
        // @ts-ignore
        <WrappedComponent
          {...this.props}
          {...props}
        />
      );
    }
  };
